import axios from '@/api/config';

const questionQuery = {
  getQuestionQueryById(data) {
    return axios.get(`${process.env.BASE_URL}/questionQuery/getQuestionQuery/` + data, {});
  },
  getQuestionQuery(data) {
    return axios.get(`${process.env.BASE_URL}/questionQuery/getQuestionQuery`, {
      params: data
    });
  },
  getQuestionQueryList(data) {
    return axios.get(`${process.env.BASE_URL}/questionQuery/getQuestionQueryList`, {
      params: data
    });
  },
  getQuestionQueryTree(data) {
    return axios.get(`${process.env.BASE_URL}/questionQuery/getQuestionQueryTree`, {
      params: data
    });
  },
  questionQueryInfo(data) {
    return axios.get(`${process.env.BASE_URL}/questionQuery/questionQueryInfo`, {
      params: data
    });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/questionQuery/pageList`, data);
  },
  //答疑列表新
  pageListNew(data) {
    return axios.post(`${process.env.BASE_URL}/questionAnswering/pageList`, data);
  },
  getRelativeQuizDetail(data) {
    return axios.get(`${process.env.BASE_URL}/questionAnswering/replayquestionAnswering`, {
      params: data
    });
  },
  getWaitAnswerList(data) {
    return axios.get(`${process.env.BASE_URL}/questionAnswering/notReplayquestionAnswering`, {
      params: data
    });
  },
  quizRankList(data) {
    return axios.post(`${process.env.BASE_URL}/questionAnswering/questionAnsweringTopList`, data);
  },
  pageListquiz(data) {
    return axios.post(`${process.env.BASE_URL}/questionAnswering/questionAnsweringPageList`, data);
  },
  addQuestionQuery(data) {
    return axios.post(`${process.env.BASE_URL}/questionQuery/addQuestionQuery`, data);
  },
  updateQuestionQuery(data) {
    return axios.put(`${process.env.BASE_URL}/questionQuery/updateQuestionQuery`, data);
  },
  deleteQuestionQuery(data) {
    return axios.delete(`${process.env.BASE_URL}/questionQuery/deleteQuestionQuery`, {
      data: data
    });
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/questionQuery/exportExcel`, {
      params: data
    });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/questionQuery/importData`, data);
  },
  cancelQuestionQuery(data) {
    return axios.post(`${process.env.BASE_URL}/questionQuery/cancelQuestionQuery`, data);
  },
  replyQuestionQuery(data) {
    return axios.post(`${process.env.BASE_URL}/questionQuery/replyQuestionQuery`, data);
  },



  //答疑 新详情题干
  getQuestionAnswering(data) {
    return axios.get(`${process.env.BASE_URL}/questionAnswering/getQuestionAnswering`, {
      params: data
    });
  },

  //  答疑 回答问题
  answer(data) {
    return axios.post(`${process.env.BASE_URL}/questionAnswering/answer`, data);
  },
};

export default questionQuery;



// WEBPACK FOOTER //
// ./src/api/questionQuery.js